import { Controller } from "@hotwired/stimulus";

// Sortie de stock d'un lot de pharmacie (GO4SHEALTH) : le choix du lot
// change l'adresse du formulaire, chaque lot ayant la sienne.
export default class extends Controller {
  retarget(event) {
    this.element.action = event.target.value;
  }
}
